/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import DocumentTitle from "../../utils/DocumentTitle";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { isValidEmail } from "../../utils/validators";

import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { IoIosArrowBack } from "react-icons/io";
import M_logo from "../../assets/logo M.png";
import axios from "axios";
const { jwtDecode } = require("jwt-decode");

const Profile = () => {
  DocumentTitle("Mangas.IO translator");
  // show hide sub list
  const [toggleSubList, setToggleSubList] = useState(false);
  const [profile, setProfile] = useState(true);
  const [password, setPassword] = useState(false);
  const [addUser, setAddUser] = useState(false);
  const [addOrganisation, setAddOrganisation] = useState(false);
  const [manageUsers, setManageUsers] = useState(false);

  const [emailIsEmpty] = useState(false);
  const [lastNameEmpty] = useState(false);
  const [passwordIsEmpty] = useState(false);
  const [loggedUser, setLoggedUser] = useState({});
  const [updateUser, setUpdateUser] = useState({});
  const [organisationCreated, setOrganisationCreated] = useState("");
  const [organisations, setOrganisations] = useState([]);
  const emailSearchRef = useRef(null);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("login_user"));
    console.log("user : ", user);
    setLoggedUser(user);
    setUpdateUser({
      New_First_Name: user?.username?.split(" ")[0],
      New_Last_Name: user?.username?.split(" ")[1],
      new_email: user?.email,
      new_role: user?.role,
      organisation: user?.organisation,
    });

    return () => {
      document.removeEventListener("click", handdleClick);
    };
  }, []);

  // get organisations
  useEffect(() => {
    const token = localStorage.getItem("login_token");
    if (token && loggedUser?.role === "Admin") {
      try {
        axios
          .get(`${process.env.REACT_APP_HOST_API}/api/organisation/getAll`, {
            headers: { Authorization: token },
          })
          .then((res) => {
            if (res.status === 200) {
              console.log("organisations : ", res.data);
              setOrganisations([...res.data]);
            }
          });
      } catch (error) {
        toast.error("Cant get organisations");
      }
    }
  }, [loggedUser?.role, organisationCreated]);

  console.log("loggedUser : ", loggedUser);
  const showHideSubList = async () => {
    setToggleSubList(!toggleSubList);
  };

  const handdleClick = (e) => {
    console.log("e : ", e.target.id);
    if (toggleSubList && e.target.id !== "avatar") {
      setToggleSubList(false);
    }
  };

  document.addEventListener("click", handdleClick);

  const toggleInfoSetting = (e) => {
    if (e.target.id === "profile") {
      setProfile(true);
      setPassword(false);
      setAddUser(false);
      setAddOrganisation(false);
      setManageUsers(false);
    } else if (e.target.id === "password") {
      setProfile(false);
      setPassword(true);
      setAddUser(false);
      setAddOrganisation(false);
      setManageUsers(false);
    } else if (e.target.id === "addUser") {
      setProfile(false);
      setPassword(false);
      setAddUser(true);
      setAddOrganisation(false);
      setManageUsers(false);
    } else if (e.target.id === "addOrganisation") {
      setProfile(false);
      setPassword(false);
      setAddUser(false);
      setAddOrganisation(true);
      setManageUsers(false);
    } else if (e.target.id === "manageUsers") {
      setProfile(false);
      setPassword(false);
      setAddUser(false);
      setAddOrganisation(false);
      setManageUsers(true);
    }
  };

  // if (profile){
  //     const token = localStorage.getItem("login_token");
  //     const userId = jwtDecode(token).utilisateur.id;
  //     console.log("eto")
  //     if (token){
  //         try{
  //             axios.get(`http://${process.env.REACT_APP_HOST_IP}:${process.env.REACT_APP_SERVER_BACKEND_PORT}/api/user/${userId}`, {headers: { 'Authorization': token }}).then(res => {
  //                 if (res.status === 200) {
  //                     const email = res.data.email;
  //                     const role = res.data.role;
  //                     const fullName = res.data.nom_utilisateur.trim().split(/\s+/);
  //                     const lastName = fullName.pop();
  //                     const firstName = fullName.join(" ");
  //                     const newFirstName = document.getElementById("New First Name");
  //                     const newLastName = document.getElementById("New Last Name");
  //                     const newEmail = document.getElementById("new email");
  //                     const newRole = document.getElementById("new role");
  //                 }
  //             })
  //         }
  //         catch(error){
  //             console.log(error);
  //         }
  //     }
  // }

  const addOrganisationHandler = async (e) => {
    e.preventDefault();
    let allFilled = false;
    let credentials = new FormData(e.currentTarget);
    let name = credentials.get("name");
    let address = credentials.get("address") || "";
    let country = credentials.get("country") || "";
    let city = credentials.get("city") || "";
    const data = { name: name, address: address, country: country, city: city };
    const token = localStorage.getItem("login_token");
    if (name) {
      allFilled = true;
    }
    if (allFilled) {
      console.log("data : ", data);
      if (token) {
        try {
          const res = await axios.post(
            `${process.env.REACT_APP_HOST_API}/api/organisation/create`,
            data,
            {
              headers: { Authorization: token },
            }
          );
          console.log("Sending organisation data : ", data);
          if (res.status === 200) {
            toast.success("The organisation has been created successfully.");
            setOrganisationCreated(res.data.name);
          }
        } catch (error) {
          toast.error("Error when creating organisation.");
          console.log(error);
        }
      }
    } else {
      toast.error("Name must be filled");
    }
  };

  const createUser = async (e) => {
    e.preventDefault();
    let credentials = new FormData(e.currentTarget);
    let email = credentials.get("email");
    let firstName = credentials.get("First Name");
    let lastName = credentials.get("Last Name");
    let role = credentials.get("role");
    let organisation =
      credentials.get("organisation") || loggedUser.organisation;
    let nom_utilisateur = firstName ? firstName + " " + lastName : lastName;
    const signUpData = {
      email: email,
      nom_utilisateur: nom_utilisateur,
      mot_de_passe: "mangasio",
      role: role,
      organisation: organisation,
    };
    console.log("signUpData : ", signUpData);
    const token = localStorage.getItem("login_token");
    const validMail = await isValidEmail(email);
    if (!validMail) {
      toast.error("Please provide a valid mail address format.");
    }
    if (token && validMail) {
      try {
        const res = await axios.post(
          `http://${process.env.REACT_APP_HOST_IP}:${process.env.REACT_APP_SERVER_BACKEND_PORT}/api/auth/signup`,
          signUpData
        );
        console.log("Sending signup data : ", signUpData);
        if (res.status === 201) {
          toast.success("The account has been created with default password.");
          console.log("signed up");
        }
      } catch (error) {
        console.log("error creating user :", error);
        toast.error(error.response.data.message);
      }
    }
  };

  const resetPasswordHandler = async (e) => {
    e.preventDefault();
    let credentials = new FormData(e.currentTarget);
    let oldPassword = credentials.get("old password");
    let newPassword = credentials.get("new password");
    if (oldPassword === newPassword) {
      toast.error(
        "The new password can't be the same to the current password."
      );
    }
    const resetPwdData = { ancien_mdp: oldPassword, nouveau_mdp: newPassword };
    const token = localStorage.getItem("login_token");
    if (token && oldPassword !== newPassword) {
      const userId = jwtDecode(token).utilisateur.id;
      console.log("eto");
      try {
        const res = await axios.put(
          `http://${process.env.REACT_APP_HOST_IP}:${process.env.REACT_APP_SERVER_BACKEND_PORT}/api/user/resetPassword/${userId}`,
          resetPwdData,
          { headers: { Authorization: token } }
        );
        console.log("Sending reset password data : ", resetPwdData);
        if (res.status === 200) {
          toast.success("Your password has been changed successfully.");
          console.log("Your password has been changed successfully.");
        }
      } catch (error) {
        if (error.response.status === 400) {
          toast.error("Wrong old password");
        }
        console.log(error.message || error);
      }
    }
  };

  const modifyProfile = async (e) => {
    e.preventDefault();
    let credentials = new FormData(e.currentTarget);
    let email = credentials.get("new_email");
    let firstName = credentials.get("New_First_Name");
    let lastName = credentials.get("New_Last_Name");
    let role = loggedUser.role;
    let organisation = loggedUser.organisation;
    let nom_utilisateur = firstName ? firstName + " " + lastName : lastName;
    const validMail = await isValidEmail(email);
    var mailOk = false;
    if (email === "") {
      mailOk = true;
    }
    if (email !== "" && validMail) {
      mailOk = true;
    }
    const newData = {};

    if (email) newData["email"] = email;
    if (nom_utilisateur) newData["nom_utilisateur"] = nom_utilisateur;
    if (role) newData["role"] = role;
    if (organisation) newData["organisation"] = organisation;
    const token = localStorage.getItem("login_token");
    const userId = jwtDecode(token).utilisateur.id;

    if (!mailOk) {
      toast.error("Please provide a valid mail address format");
    }
    if (token && mailOk) {
      try {
        const res = await axios.put(
          `http://${process.env.REACT_APP_HOST_IP}:${process.env.REACT_APP_SERVER_BACKEND_PORT}/api/user/${userId}`,
          newData,
          { headers: { Authorization: token } }
        );
        console.log("Sending profile update data : ", newData);
        if (res.status === 200) {
          toast.success("Your account has been updated.");
          console.log("user updated");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const onChangeProfile = (e) => {
    setUpdateUser({ ...updateUser, [e.target.name]: e.target.value });
  };

  const managePasswordHandler = async (e) => {
    e.preventDefault();
    const email = emailSearchRef.current.value.trim();
    if (!email) return toast.warning("Email is required");
    const validMail = await isValidEmail(email);
    if (!validMail) return toast.warning("Invalid email format");
    const token = localStorage.getItem("login_token");
    if (token && email && validMail) {
      try {
        const body = {
          email,
          user_id: loggedUser.id,
        };

        const res = await axios.post(
          `http://${process.env.REACT_APP_HOST_IP}:${process.env.REACT_APP_SERVER_BACKEND_PORT}/api/user/resetPassword`,
          body,
          {
            headers: { Authorization: token },
          }
        );
        if (res.data.success) {
          console.log("managePasswordHandler res ", res.data.message);
          toast.success(res.data.message);
        }
      } catch (error) {
        console.log("managePasswordHandler err : ", error);
        toast.error(error.response.data.message);
      }
    }
  };

  return (
    <div className="profile_container">
      <div className="profile_header">
        <div className="profile_logo">
          <img src={M_logo} alt="MangasIO_Logo" />
          {/* /../assets/logo M.png */}
          <Link to="/series" className="back">
            <IoIosArrowBack />
          </Link>
        </div>
        <div className="profile_search">
          <div className="input">Me {">"} profile</div>
        </div>
        <div className="profile_avatar">
          <div
            id="avatar"
            className="avatar"
            onClick={showHideSubList}
            style={
              toggleSubList
                ? {
                    border: "1px solid rgb(214, 65, 10)",
                    color: "rgb(214, 65, 10)",
                  }
                : { border: "none", color: "black" }
            }
          >
            {loggedUser?.username && loggedUser?.username[0]?.toUpperCase()}
          </div>
          {toggleSubList && (
            <div className="sub_list">
              <Link className="item" to="/logout">
                Sign out
              </Link>
            </div>
          )}
        </div>
      </div>
      <div className="profile_content">
        <h2>Profile</h2>
        <div className="profile_settings">
          <ul className="options">
            <li
              id="profile"
              style={
                profile ? { color: "#775DA6", borderColor: "#775DA6" } : {}
              }
              onClick={toggleInfoSetting}
            >
              Profile
            </li>
            <li
              id="password"
              style={
                password ? { color: "#775DA6", borderColor: "#775DA6" } : {}
              }
              onClick={toggleInfoSetting}
            >
              Password
            </li>
            {loggedUser?.role === "Admin" && (
              <li
                id="addUser"
                style={
                  addUser ? { color: "#775DA6", borderColor: "#775DA6" } : {}
                }
                onClick={toggleInfoSetting}
              >
                Add User
              </li>
            )}
            {loggedUser?.role === "Admin" &&
              loggedUser?.organisation === "mangasIO" && (
                <li
                  id="addOrganisation"
                  style={
                    addOrganisation
                      ? { color: "#775DA6", borderColor: "#775DA6" }
                      : {}
                  }
                  onClick={toggleInfoSetting}
                >
                  Add Organisation
                </li>
              )}
            {loggedUser?.role === "Admin" &&
              loggedUser?.organisation === "mangasIO" && (
                <li
                  id="manageUsers"
                  style={
                    manageUsers
                      ? { color: "#775DA6", borderColor: "#775DA6" }
                      : {}
                  }
                  onClick={toggleInfoSetting}
                >
                  Manage Users
                </li>
              )}
          </ul>

          {profile && (
            <form action="" onSubmit={modifyProfile}>
              <div className="profile_details">
                <div className="profile_details_content">
                  <div className="profile_details_content_left">
                    <div className="input_block">
                      <label htmlFor="first_name">First Name</label>
                      <input
                        type="text"
                        name="New_First_Name"
                        id="New_First_Name"
                        placeholder="First Name"
                        value={updateUser?.New_First_Name}
                        onChange={onChangeProfile}
                      />
                    </div>
                    <div className="input_block">
                      <label htmlFor="email">Email</label>
                      <input
                        type="text"
                        name="new_email"
                        id="new_email"
                        placeholder={
                          emailIsEmpty ? "Email is required" : "Email Adress"
                        }
                        value={updateUser?.new_email}
                        onChange={onChangeProfile}
                        style={
                          emailIsEmpty
                            ? { border: "1px solid red" }
                            : { border: "1px solid #DCDCDC" }
                        }
                      />
                    </div>
                  </div>

                  <div className="profile_details_content_right">
                    <div className="input_block">
                      <label htmlFor="last_name">Last Name</label>
                      <input
                        type="text"
                        name="New_Last_Name"
                        id="New_Last_Name"
                        placeholder={
                          lastNameEmpty ? "Last name is required" : "Last name"
                        }
                        value={updateUser?.New_Last_Name}
                        onChange={onChangeProfile}
                        style={
                          lastNameEmpty
                            ? { border: "1px solid red" }
                            : { border: "1px solid #DCDCDC" }
                        }
                      />
                    </div>
                    <div className="input_block">
                      <label htmlFor="new_role">Function</label>
                      <select
                        name="new_role"
                        id="new_role"
                        value={updateUser?.new_role}
                        style={{ opacity: "0.5", cursor: "not-allowed" }}
                        disabled
                      >
                        <option value="Translator">Translator</option>
                        <option value="Admin">Admin</option>
                        <option value="Letter-Writer">Letter-Writer</option>
                      </select>
                    </div>
                    <div className="input_block">
                      <label htmlFor="organisation">Organisation</label>
                      <input
                        type="text"
                        name="organisation"
                        id="organisation"
                        value={updateUser?.organisation}
                        style={{ opacity: "0.5", cursor: "not-allowed" }}
                        readOnly
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <div className="profile_details_content_btns">
                  <button className="save" type="submit">
                    Save
                  </button>
                </div>
              </div>
            </form>
          )}

          {password && (
            <form action="" onSubmit={resetPasswordHandler}>
              <div className="password_content">
                <div className="password_left">
                  <div className="input_block">
                    <label htmlFor="old_password">Old Password</label>
                    <input
                      type="text"
                      name="old password"
                      id="old password"
                      placeholder="Old Password"
                      style={{
                        WebkitTextSecurity: "disc",
                        textSecurity: "disc",
                      }}
                      required
                    />
                  </div>
                </div>
                <div className="password_right">
                  <div className="input_block">
                    <label htmlFor="new_password">New Password</label>
                    <input
                      type="text"
                      name="new password"
                      id="new password"
                      placeholder="New Password"
                      style={{
                        WebkitTextSecurity: "disc",
                        textSecurity: "disc",
                      }}
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="password_btns">
                <button className="save" type="submit">
                  Save
                </button>
              </div>
            </form>
          )}

          {addUser && loggedUser?.role === "Admin" && (
            <form action="" onSubmit={createUser}>
              <div className="profile_details">
                <div className="profile_details_content">
                  <div className="profile_details_content_left">
                    <div className="input_block">
                      <label htmlFor="first_name">First Name</label>
                      <input
                        type="text"
                        name="First Name"
                        id="First Name"
                        placeholder="First Name"
                      />
                    </div>
                    <div className="input_block">
                      <label htmlFor="email">Email</label>
                      <input
                        type="text"
                        name="email"
                        id="email"
                        placeholder={
                          emailIsEmpty ? "Email is required" : "Email Adress"
                        }
                        style={
                          emailIsEmpty
                            ? { border: "1px solid red" }
                            : { border: "1px solid #DCDCDC" }
                        }
                        required
                      />
                    </div>
                  </div>

                  <div className="profile_details_content_right">
                    <div className="input_block">
                      <label htmlFor="last_name">Last Name</label>
                      <input
                        type="text"
                        name="Last Name"
                        id="Last Name"
                        placeholder={
                          lastNameEmpty ? "Last name is required" : "Last name"
                        }
                        style={
                          lastNameEmpty
                            ? { border: "1px solid red" }
                            : { border: "1px solid #DCDCDC" }
                        }
                        required
                      />
                    </div>
                    <div className="input_block">
                      <label htmlFor="role">Function</label>
                      <select name="role" id="role">
                        <option value="Translator">Translator</option>
                        <option value="Admin">Admin</option>
                        <option value="Letter-Writer">Letter-Writer</option>
                      </select>
                    </div>
                    {loggedUser?.organisation === "mangasIO" && (
                      <div className="input_block">
                        <label htmlFor="organisation">Organisation</label>
                        <select
                          name="organisation"
                          id="organisation"
                          defaultValue="mangasIO"
                        >
                          {[...organisations].reverse()?.map((o, i) => (
                            <option key={i} value={`${o.name}`}>
                              {o.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                  </div>
                </div>
                <div className="profile_details_content_btns">
                  <button className="save" type="submit">
                    Save
                  </button>
                </div>
              </div>
            </form>
          )}
          {addOrganisation &&
            loggedUser?.role === "Admin" &&
            loggedUser?.organisation === "mangasIO" && (
              <form action="" onSubmit={addOrganisationHandler}>
                <div className="profile_details">
                  <div className="profile_details_content">
                    <div className="profile_details_content_left">
                      <div className="input_block">
                        <label htmlFor="organisation_name">Name</label>
                        <input
                          type="text"
                          name="name"
                          id="Organisation Name"
                          placeholder="Organisation Name"
                          required
                        />
                      </div>
                      <div className="input_block">
                        <label htmlFor="organisation_address">Address</label>
                        <input
                          type="address"
                          name="address"
                          id="organisation_address"
                          placeholder="Address"
                        />
                      </div>
                    </div>

                    <div className="profile_details_content_right">
                      <div className="input_block">
                        <label htmlFor="country">Country</label>
                        <input
                          type="text"
                          name="country"
                          id="Country"
                          placeholder="Country"
                        />
                      </div>
                      <div className="input_block">
                        <label htmlFor="city">City</label>
                        <input
                          type="text"
                          name="city"
                          id="City"
                          placeholder="City"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="profile_details_content_btns">
                    <button className="save" type="submit">
                      Add
                    </button>
                  </div>
                </div>
              </form>
            )}
          {manageUsers && (
            <form action="" onSubmit={managePasswordHandler}>
              <div className="manage_user_content">
                <div className="manage_user_left">
                  <div className="input_block">
                    <label htmlFor="Email">Email</label>
                    <input
                      type="email"
                      ref={emailSearchRef}
                      name="email"
                      id="email"
                      placeholder="User's email"
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="manage_user_password_btns">
                <button className="save" type="submit">
                  Reset Password
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Profile;
